import BuildingPage from "../BuildingPage";
import PaymentsOut from "./PaymentsOut";
import PaymentsIn from "./PaymentsIn";
import Settings from "./Settings";
import Home from "./Home";
import OpenFinance from "./OpenFinance";
import Caixas from "./Caixas";

export const paths = [
  {
    path: "/financial/home",
    component: Home, //Home
  },
  {
    path: "/financial/pay-out",
    component: PaymentsOut, //PaymentsOut
  },
  {
    path: "/financial/pay-in",
    component: PaymentsIn, //PaymentsIn
  },
  {
    path: "/financial/settings",
    component: Settings,
  },
  {
    path: "/financial/open-finance",
    component: OpenFinance,
  },
  {
    path: "/financial/caixas",
    component: Caixas,
  },
  {
    path: "/building-page...",
    component: BuildingPage, //BuildingPage
  },
];
export const FinancialRouters = {
  icon: "wallet",
  path: "/financial",
  label: "Financeiro",
  badge: "beta",
  tree: [
    {
      icon: "home",
      path: "/financial/home",
      label: "Resumo",
    },
    {
      icon: "university",
      path: "/financial/open-finance",
      label: "Extrato Bancário",
    },
    {
      icon: "cash-register",
      path: "/financial/caixas",
      label: "Caixas",
    },
    {
      icon: "money-check-alt",
      path: "/financial/pay-out",
      label: "Contas a Pagar",
    },
    {
      icon: "hand-holding-usd",
      path: "/financial/pay-in",
      label: "Contas a Receber",
    },
    {
      icon: "cog",
      path: "/financial/settings",
      label: "Cadastros",
    },
    // {
    //   icon: "file-invoice-dollar",
    //   path: "/building-page...",
    //   label: "Antecipar Boleto",
    // },
    // {
    //   icon: "tags",
    //   path: "/building-page...",
    //   label: "Concilicação Bancária",
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/routers.jsx